import type { FC } from 'react';
import { Box, Button, Code, Group, Text } from '@mantine/core';

interface FileSaveConflictModalProps {
    filename: string;
    onCancel: () => void;
    onReload: () => void;
    onSaveAnyway: () => void;
}

const FileSaveConflictModal: FC<FileSaveConflictModalProps> = ({
    filename,
    onCancel,
    onReload,
    onSaveAnyway
}) => (
    <Box className="flex flex-col gap-4">
        <Text size="sm">
            <Code>{filename}</Code> was modified by another writer after you
            opened it. Reload to discard your local changes and pull the latest
            version, or Save anyway to overwrite the remote copy with what you
            have now.
        </Text>
        <Group gap="sm" justify="flex-end">
            <Button variant="default" onClick={onCancel}>
                Cancel
            </Button>
            <Button color="red" variant="outline" onClick={onReload}>
                Reload (lose mine)
            </Button>
            <Button onClick={onSaveAnyway}>Save anyway</Button>
        </Group>
    </Box>
);

export default FileSaveConflictModal;
